import { Link, useLocation } from "react-router-dom";
import { supabase } from "../supabaseClient";

const ROLE_LABELS = {
  admin:    { label: "Admin",     color: "#f59e0b" },
  uploader: { label: "Uploader",  color: "#60a5fa" },
  family:   { label: "Family",    color: "#34d399" },
  readonly: { label: "View Only", color: "#94a3b8" },
};

export default function Navbar({ role, canUpload, isAdmin }) {
  const location = useLocation();
  const roleInfo = ROLE_LABELS[role] || ROLE_LABELS.readonly;

  async function handleSignOut() {
    await supabase.auth.signOut();
  }

  return (
    <nav className="navbar">
      <div className="nav-brand">
        <span className="nav-logo">👶</span>
        <span className="nav-title">Staley Family</span>
      </div>

      <div className="nav-links">
        <Link className={`nav-link ${location.pathname === "/" ? "nav-active" : ""}`} to="/">
          Gallery
        </Link>
        <Link className={`nav-link ${location.pathname === "/albums" ? "nav-active" : ""}`} to="/albums">
          Albums
        </Link>
        {canUpload && (
          <Link className={`nav-link ${location.pathname === "/upload" ? "nav-active" : ""}`} to="/upload">
            Upload
          </Link>
        )}
        {isAdmin && (
          <Link className={`nav-link nav-admin ${location.pathname === "/admin" ? "nav-active" : ""}`} to="/admin">
            ⚙️ Users
          </Link>
        )}
      </div>

      <div className="nav-right">
        <span className="role-badge" style={{ background: roleInfo.color }}>
          {roleInfo.label}
        </span>
        <button className="signout-btn" onClick={handleSignOut}>
          Sign Out
        </button>
      </div>
    </nav>
  );
}
